import React from 'react'
import { Layout, Showcase, Header, SectionTitle } from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        inProgress="true"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        description={data.description}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <SectionTitle>Usage</SectionTitle>
        <Showcase
          site={data.site}
          title="Inline Error"
          text="An inline error is a filled container that appears below an input in the error state. Inline Errors are directly attached to and affect the input field that requires correction. The message in the error container will give the user clear direction on how to resolve the error. Inline errors must always be used with the sibling input element in the error state."
          code={code.input}
        >
          <label class="c-label" for="input-1">
            Label Name
          </label>
          <input
            type="text"
            class="c-text-field c-text-field--error"
            placeholder="e.g. Homer J. Simpson"
            id="input-1"
          />
          <span class="c-inline-error">
            <i class="icon icon--error c-inline-error__icon"></i>
            <span class="c-inline-error__content">
              Please enter your full name.
            </span>
          </span>
        </Showcase>

        {/* <Showcase
          site={data.site}
          title="Inline Warning"
          text="Inline errors directly affect the input field that requires correction. The input's container will change color to draw the user's attention and a message below the input will give the user clear direction on how to resolve the error."
          code={code.warning}
        >
          <div>
            <label class="c-label" for="input-1">
              Label Name
            </label>
            <input
              type="text"
              class="c-text-field c-inline-error__input--warning"
              placeholder="e.g. Homer J. Simpson"
              id="input-1"
            />
            <span class="c-inline-error--warning">
              <i class="icon icon--exclamation c-inline-error__icon--warning"></i>
              <span class="c-inline-error__content">
                Please enter your full name.
              </span>
            </span>
          </div>
        </Showcase> */}
      </Layout>
    </>
  )
}

export const code = {
  input: `<label class="c-label" for="input-1">Label Name</label>
  <input 
    type="text" 
    class="c-text-field c-text-field--error" 
    placeholder="e.g. Homer J. Simpson"
    id="input-1" />
  <span class="c-inline-error">
      <i class="icon icon--error c-inline-error__icon"></i>
      <span class="c-inline-error__content">
          Please enter your full name.
      </span>
  </span>
</div>
`,
  warning: `<div>
<label class="c-label" for="input-1">
  Label Name
</label>
<input
  type="text"
  class="c-text-field c-inline-error__input--warning"
  placeholder="e.g. Homer J. Simpson"
  id="input-1"
/>
<span class="c-inline-error--warning">
  <i class="icon icon--exclamation c-inline-error__icon--warning"></i>
  <span class="c-inline-error__content">
    Please enter your full name.
  </span>
</span>
</div>`,
}
